<template lang="pug">
    v-layout
      v-btn(v-if='estado_del_documento  == "esperando"'  icon color='secondary' @click='editItem(id)')
          v-icon(small) far fa-edit
      v-btn(v-if='estado_del_documento  == "esperando"'  icon color='secondary' @click='process({id ,host})'  )  
        v-icon(small) fas fa-play 
      v-btn(v-if='estado_del_documento  == "procesando"' icon color='secondary')
        v-icon(small) fas fa-circle-notch fa-spin
      v-btn(v-if='estado_del_documento  == "procesado" || estado_del_documento=="proveedor_seleccionado"'  icon color='secondary' disabled) 
        v-icon(small) fas fa-check 
      tabla_de_cotizaciones(v-if='estado_del_documento  == "procesado"|| estado_del_documento=="proveedor_seleccionado"' :idCotizacion ='id' )
      documento_de_cotizacion(:idCotizacion='id')
</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
  data:()=>({
    host:window.location.host,
  }),
  props:{
    estado_del_documento: String,
    id: String,
    message: String,
    link: String
  },
  methods: {
    ...mapActions({
      process: 'Cotizaciones/process',
      unProcess: 'Cotizaciones/unProcess',
      editItem: 'Cotizaciones/get',
      deleteItem: 'Cotizaciones/clean',

    }),
  },
  components: {
    tabla_de_cotizaciones: ()=>import('.././componentes/tabla_de_cotizaciones'),
    documento_de_cotizacion:()=>import('.././componentes/documento_de_cotizacion'),
  },
}
</script>
